<script lang="ts">
	import { tooltip } from "tooltip"

	interface Props<T extends ReadonlyArray<string>> {
		options: T
		selectedOption?: T[number]
		optionInfo?: { [index: string]: string }
		fontSize?: string
		onChange?: (newSelect: T[number]) => void
	}

	let {
		options,
		selectedOption = $bindable(undefined),
		optionInfo = {},
		fontSize = undefined,
		onChange,
	}: Props<any> = $props()

	function select(option: string) {
		selectedOption = option
		if (onChange) onChange(option)
	}
</script>

<div class="text-row-selector">
	{#each options as option}
		<button
			type="button"
			class="link-button {selectedOption === option ? 'selected' : ''}"
			style={fontSize ? `font-size: ${fontSize};` : ""}
			onclick={() => select(option)}
			use:tooltip={{ content: optionInfo[option], pointing: "top" }}>{option}</button
		>
	{/each}
</div>

<style>
	.text-row-selector {
		display: flex;
		flex-direction: row;
	}

	.text-row-selector :global(.info-dialogue-button) {
		margin: 0;
		margin-top: 0.25rem;
		margin-left: -0.75rem;
	}

	button.link-button {
		transform: none;
		font-size: var(--h3);
		padding: 0 0.5rem;
		text-decoration: none;
		color: var(--color-text);
		border-radius: 0;
		box-shadow: none;
	}

	button.link-button:hover,
	button.link-button:focus-visible {
		color: var(--color-main);
	}

	button.link-button.selected {
		color: var(--color-text-light);
	}

	button.link-button {
		border-right: 1px solid var(--color-border);
	}

	button.link-button:last-of-type {
		border: none;
	}

	button:first-of-type {
		padding-left: 0;
	}

	button:last-of-type {
		/* padding-right: 0; */
	}
</style>
